export const ONBOARDING_POST_URL_KEY = 'onbardingPremiumPostUrl'
